export default __webpack_public_path__ + "pdf/user-agreement-2018-05-30_57d7f57fdbeee56afa0519a5ecf085d6.pdf";